import { FormattedMessage, injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Button, Result } from 'antd'

/**
 * Where the backend sends the user when the magic link is no longer usable.
 * It used to print raw JSON in the browser instead.
 *
 * Deliberately one message for both causes - expired and already used - because
 * telling them apart would need a second query and does not change what the user
 * has to do next, which is ask for a new link.
 */
const InvalidLink = props => {
  const { intl } = props

  return (
    <Result
      status={'error'}
      title={intl.formatMessage({ id: 'error.title.invalidLink' })}
      subTitle={intl.formatMessage({ id: 'error.description.invalidLink' })}
      extra={
        <Link to={'/'}>
          <Button type={'primary'} size={'large'}>
            <FormattedMessage id={'error.action.invalidLink'} />
          </Button>
        </Link>
      }
    />
  )
}

export default injectIntl(InvalidLink)
